import { TransformedOrder } from "../types/orderApiTypes";

const hasConsent = (category: "analytics" | "marketing") => {
  const consent = window.ThemeConsent?.getConsent();
  return consent ? (consent as any)[category] : false;
};

/**
 * Fires GA4 and Meta Pixel purchase events.
 * Safe to call directly from the component lifecycle.
 */
export const trackPurchase = (order: TransformedOrder) => {
  // Guard against invalid/failed orders
  if (["failed", "cancelled", "refunded"].includes(order.status)) {
    return;
  }

  // Common Data
  const transactionId = String(order.id);
  const currency = order.currencyCode || "TRY";
  // WooCommerce REST API returns strings for totals, convert to number
  const value = parseFloat(
    order.totals.rawTotalPrice ||
      order.totals.totalPrice.replace(/[^0-9.]/g, "")
  );
  const tax = parseFloat(
    order.totals.rawTotalTax || order.totals.totalTax.replace(/[^0-9.]/g, "")
  );
  const shipping = parseFloat(
    order.totals.totalShipping?.replace(/[^0-9.]/g, "") || "0"
  );

  // Map Items
  const items = order.items.map((item) => ({
    item_id: String(item.id),
    item_name: item.name,
    price: parseFloat(item.rawPrice || "0"),
    quantity: item.quantity,
    item_variant: item.variation
      .map((v) => `${v.attribute}:${v.value}`)
      .join("|"),
  }));

  // --- GA4 Purchase ---
  if (hasConsent("analytics") && typeof window.gtag === "function") {
    window.gtag("event", "purchase", {
      transaction_id: transactionId,
      value: value,
      tax: tax,
      shipping: shipping,
      currency: currency,
      items: items,
    });
    console.log("[Analytics] GA4 Purchase Event Fired", { transactionId });
  }

  // --- Meta Pixel Purchase ---
  if (hasConsent("marketing") && typeof window.fbq === "function") {
    window.fbq("track", "Purchase", {
      content_type: "product",
      content_ids: items.map((i) => i.item_id),
      value: value,
      currency: currency,
      num_items: order.itemsCount,
      order_id: transactionId, // Advanced Matching parameter
    });
    console.log("[Analytics] Meta Purchase Event Fired", { transactionId });
  }
};
